import React from "react";
import { Flex, Typography } from "antd";
import { SvgIcons } from "Icon/SvgIcons";
import TooltipWrapper from "components/CandidateProfile/TooltipWrapper";
const { Title, Text } = Typography;

interface TitleProps {
  text?: string | number;
  className?: string;
  type?: string;
  year?: number;
  Icon?: string;
  font?: string;
  color?: string;
  tooltipText?: string;
}

export const Title3: React.FC<TitleProps> = ({
  text,
  className,
  color = "text-text-primary-900",
}) => {
  return <h3 className={`${className} ${color} md:text-xl sm:text-lg text-sm`}>{text}</h3>;
};
export const Title4: React.FC<TitleProps> = ({
  text,
  className,
  color = "text-text-primary-900",
}) => {
  return (
    <h4 className={`text-lg ${className} ${color}`}>
      {text}
    </h4>
  );
};


export const Title5: React.FC<TitleProps> = ({ text, className, color = "text-text-primary-900" }) => {
  return (
    <h5 className={`${color} text-base ${className} mb-0`} >
      {text}
    </h5>
  );
};

export const MediumTitle: React.FC<TitleProps> = ({ text, className, color = "text-text-primary-900" }) => {
  return <span className={`text-sm ${color} ${className}`}>{text}</span>;
};

export const SmallTitle: React.FC<TitleProps> = ({
  text,
  className = "text-text-heading",
  font = "font-bold",
}) => {
  return <h6 className={`sm:text-sm  ${font} ${className}`}>{text}</h6>;
};

export const ExtraSmallTitle: React.FC<TitleProps> = ({ text, className = "font-semibold", tooltipText }) => {
  if (tooltipText) return (
    <TooltipWrapper text={tooltipText!} placement="right">
      <span className={`text-xs ${className}`}>{text}</span>
    </TooltipWrapper>
  );
  return <span className={`text-xs ${className}`}>{text}</span>;
};
export const ExtraExtraSmallTitle: React.FC<TitleProps> = ({
  text,
  className = "font-semibold",
}) => {
  return <span className={`text-font-size ${className}`}>{text}</span>;
};

export const TextWithBg: React.FC<TitleProps> = ({
  text,
  className = "text-gray-blue-700 bg-utility-blue-dark-50",
}) => {
  return (
    <span className={`text-xs font-medium rounded-full sm:px-2 px-0.5 ${className}`}>{text}</span>
  );
};

export const ExperienceText: React.FC<TitleProps> = ({ type, year }) => {
  return (
    <Flex className="px-2 capitalize border-r items-center" gap={3}>
      <Flex className="items-center text-text-quaternary font-medium text-sm gap-1 capitalize">
        {SvgIcons.checkCircleSvg} {type}:
      </Flex>
      <span className="text-text-tertiary font-semibold whitespace-nowrap">{year} yrs</span>
    </Flex>
  );
};

export const TextWithArrow: React.FC<TitleProps> = ({ text, Icon }) => {
  return (
    <Flex gap={3} className="px-2 items-center font-medium cursor-pointer">
      {Icon && <img src={Icon} alt="" />}
      <Text className="text-border-theme text-xs">{text}</Text>
      {SvgIcons.primaryArrowSvg}
    </Flex>
  );
};
